import React from 'react'
import {
    Route,
    Link,
    Switch
} from 'react-router-dom'

import Header from '../components/header/Header';
import TopImage from '../components/banner/TopImage';
import createHistory from 'history/createBrowserHistory'
import Hello from '../containers/Hello';
import '../static/css/Index.css';

import NewHome from '../containers/home/NewHome';
import BookDetail from '../containers/detail/BookDetail';
import {ConnectedRouter} from 'react-router-redux';

const history = createHistory();






const RouterMap = () => (



    <ConnectedRouter history={history}>


        <div className="wrap">

            <Header/>
            <TopImage/>
            <Switch>
                <Route exact path="/" component={NewHome}/>
                <Route path="/bookDetail*" component={BookDetail}/>
                <Route path="/about" component={About}/>
                <Route path="/topics" component={Topics}/>
                <Route path="/hello" component={Hello}/>
                <Route component={NoMatch}/>
            </Switch>
        </div>
    </ConnectedRouter>
);

const About = () => (
    <div>
        <h2>About</h2>

    </div>
);


const Topics = ({match}) => (
    <div>

        <h2>Topics</h2>
        <ul>
            <li>
                <Link to={`${match.url}/rendering`}>
                    Rendering with React
                </Link>
            </li>
            <li>
                <Link to={`${match.url}/components`}>
                    Components
                </Link>
            </li>
            <li>
                <Link to={`${match.url}/props-v-state`}>
                    Props v. State
                </Link>
            </li>
        </ul>

        <Route path={`${match.url}/:topicId`} component={Topic}/>
        <Route exact path={match.url} render={() => (
            <h3>Please select a topic.</h3>
        )}/>
    </div>
);

const Topic = ({match}) => (
    <div>
        <h3>{match.params.topicId}</h3>
    </div>
);

const NoMatch = ({location}) => (
    <div>
        <h3>No match for <code>{location.pathname}</code></h3>
    </div>
);

export default RouterMap


// WEBPACK FOOTER //
// ./src/router/RouterMap.js